import { z } from 'zod';

const usernameSchema = z.object({
	username: z
		.string({
			required_error: 'Harap masukkan No. WhatsApp/Email'
		})
		.min(1, {
			message: 'Harap masukkan No. WhatsApp/Email'
		})
});

const registerSchema = z.object({
	name: z
		.string({
			required_error: 'Harap masukkan Nama Lengkap'
		})
		.min(1, {
			message: 'Harap masukkan Nama Lengkap'
		}),
	email: z
		.string({
			required_error: 'Harap masukkan Email'
		})
		.min(1, {
			message: 'Harap masukkan Email'
		})
		.email({ message: 'Email tidak valid' }),
	phone: z
		.string({
			required_error: 'Harap masukkan No. WhatsApp'
		})
		.min(10, {
			message: 'No. WhatsApp minimal 10 karakter'
		})
		.max(14, {
			message: 'No. WhatsApp maksimal 14 karakter'
		})
});

const verifyOTPSchema = z.object({
	otp_code: z
		.string({
			required_error: 'Harap masukkan Kode OTP'
		})
		.min(6, {
			message: 'Kode OTP minimal 6 karakter'
		})
		.max(6, {
			message: 'Kode OTP maksimal 6 karakter'
		})
});

const forgotPasswordSchema = usernameSchema;

const passwordSchema = z.object({
	password: z
		.string({
			required_error: 'Harap masukkan Password'
		})
		.min(6, {
			message: 'Password minimal 6 karakter'
		})
		.max(50, {
			message: 'Password maksimal 50 karakter'
		}),
	password_confirmation: z
		.string({
			required_error: 'Harap konfirmasi Password'
		})
		.min(6, { message: 'Password minimal 6 karakter' })
		.max(50, { message: 'Password maksimal 50 karakter' })
});

function passwordSchemaRefine(data: z.infer<typeof passwordSchema>) {
	return (
		data.password === data.password_confirmation,
		{
			message: 'Harap konfirmasi Password dengan benar',
			path: ['password_confirmation']
		}
	);
}

const createPasswordSchema = passwordSchema.refine(passwordSchemaRefine);

const changePasswordSchema = passwordSchema
	.merge(
		z.object({
			old_password: z
				.string({
					required_error: 'Harap masukkan Password lama'
				})
				.min(6, {
					message: 'Password Lama minimal 6 karakter'
				})
				.max(50, {
					message: 'Password Lama maksimal 50 karakter'
				})
		})
	)
	.refine(passwordSchemaRefine);

const registerOauthSchema = passwordSchema
	.merge(registerSchema.pick({ phone: true }))
	.refine(passwordSchemaRefine);

const deactivateAccountSchema = registerSchema
	.pick({ email: true })
	.merge(passwordSchema)
	.refine(passwordSchemaRefine);

const loginSchema = usernameSchema.merge(passwordSchema.pick({ password: true }));

export {
	loginSchema,
	registerSchema,
	verifyOTPSchema,
	forgotPasswordSchema,
	createPasswordSchema,
	changePasswordSchema,
	registerOauthSchema,
	deactivateAccountSchema,
	usernameSchema
};
